import { Form } from '@unform/web';
import styled from 'styled-components';

export const Wrapper = styled(Form)`
  display: flex;
  flex-direction: column;

  gap: 1rem;

  p.MuiFormHelperText-root.Mui-error {
    margin-top: 0;
  }
`;

export const GroupInput = styled.div`
  display: flex;
  align-items: center;

  gap: 1.5rem;
`;
